import React from 'react';
import { TableBody, TableCell, TableRow } from '../../../../CommonComponents/OPL/Table/Table';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';

export const EmptyManageAccounts = () => {
  return (
    <TableBody>
      <TableRow px="24">
        <TableCell width="100%">
          <Box display="flex" flexDirection="column">
            <Text fontWeight={400} color="neutral.500">
              You have not added any accounts.
            </Text>
          </Box>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};
